import { render, staticRenderFns } from "./PaowLanguageSelector.vue?vue&type=template&id=6b7a19ce&scoped=true&"
import script from "./PaowLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./PaowLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a19ce",
  null
  
)

/* custom blocks */
import block0 from "./PaowLanguageSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
